import {
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
  HostListener,
  EventEmitter,
} from "@angular/core";
import videojs from "video.js";
import qualityLable from "videojs-contrib-quality-levels";
videojs.registerPlugin("qualityLable", qualityLable);
import hlsQualitySelector from "videojs-hls-quality-selector";
videojs.registerPlugin("hlsQualitySelector", hlsQualitySelector);
import seekButon from "videojs-seek-buttons";
videojs.registerPlugin("seekButon", seekButon);
import * as $ from "jquery";
import { environment } from "src/environments/environment";
import { Router, ActivatedRoute } from "@angular/router";
import * as CryptoJS from "crypto-js";
import { AppService } from "../../app.service";
import "videojs-contrib-ads";
import "videojs-ima";
import firebase from "firebase";
import { Title } from "@angular/platform-browser";
import { BaseService } from "src/app/base/base.service";
import { formatDate } from "@angular/common";
import * as moment from "moment";
declare var google: any;

// import shareVideo from "videojs-share";
// videojs.registerPlugin("shareVideo", shareVideo);

@Component({
  selector: "app-vjs-player",
  // templateUrl: './vjs-player.component.html',
  // 'vjs-big-play-centered' class to make play button center.
  template: `
    <video
      (scroll)="onScroll($event)"
      id="my-video"
      #target
      class="video-js vjs-big-play-centered"
      controls
      aspectRatio="16:9"
      playsinline
      preload="auto"
    ></video>
  `,
  styleUrls: ["./vjs-player.component.css"],
  encapsulation: ViewEncapsulation.None,
})
export class VjsPlayerComponent implements OnInit, OnDestroy {
  userInfo: any = {};
  @ViewChild("target", { static: true }) target: ElementRef;
  @Input() options: {
    //playbackRates:any;
    aspectRatio: string;
    autoplay: boolean;
    sources: {
      src: string;
      type: string;
    }[];
    poster: string;
    videoDetail: any;
    redirectUrl: string;
    action: string;
  };
  index: string = "0";
  testData: any;
  @Output() playerStatus = new EventEmitter<any>();
  @Input() public set scrollStatus(value: any) {
    if (this.is_playing) {
      this.triggerControlBtns();
    }
  }
  timeoutPause: any;
  player: videojs.Player;
  // tslint:disable-next-line: variable-name
  is_playing: boolean;
  baseData: any = {};
  tabCount = false;
  @HostListener("window:scroll", ["$event"])
  onScroll(event: any) {
    this.getYScrollandVideoStatus(window.pageYOffset);
  }

  constructor(
    private elementRef: ElementRef,
    private route: Router,
    private router: ActivatedRoute,
    private appService: AppService,
    private titleService: Title,
    private baseService: BaseService
  ) {}

  ngOnInit(): void {
    if (localStorage.getItem("baseData")) {
      this.baseData = JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("baseData"),
          environment.secretkey
        ).toString(CryptoJS.enc.Utf8)
      );
    }
    // instantiate Video.js
    this.player = videojs(
      this.target.nativeElement,
      this.options,
      function onPlayerReady() {}
    );
    if (
      this.options.videoDetail.type == "live" &&
      this.options?.videoDetail?.channel_content?.start_time
    ) {
      let bp: any = document.querySelector(".vjs-big-play-button");
      if (this.options.action !== "done") {
        bp.style.display = "none";
      } else {
        bp.style.display = "";
      }
    }

    window.addEventListener("storage", () => {
      this.playerStatus.emit({
        isPlaying: true,
        videoStatus: "error",
        message: "VIDEO_DETAIL.MESSAGE3",
      });
    });
    /**
     * Shareing feature of social media
     */

    // var shareOptions = {
    //   socials: [
    //     "fb",
    //     "tw",
    //     //"reddit",
    //     //"gp",
    //     //"messenger",
    //     "linkedin",
    //     //"telegram",
    //     "whatsapp",
    //     //"viber",
    //     //"vk",
    //     //"ok",
    //     "mail",
    //   ],
    //   url: "Video URL",
    //   title: "Video Titele",
    //   description: "Video description",
    //   image: "http://media.w3.org/2010/05/bunny/poster.png",
    //   // required for Facebook and Messenger
    //   fbAppId: "12345",
    //   // optional for Facebook
    //   redirectUri: window.location.href + "#close",
    //   // optional for VK
    //   isVkParse: true,
    //   // optinal embed code
    //   embedCode:
    //     '<iframe src="' +
    //     window.location.href +
    //     '" width="560" height="315" frameborder="0" allowfullscreen></iframe>',
    // };
    // this.player.share(shareOptions);

    /**
     * Seek button
     */

    this.player.seekButtons({
      forward: 10,
      back: 10,
    });

    /**
     * HLS Quality selector
     */

    this.player.hlsQualitySelector({
      displayCurrentQuality: true,
      vjsIconClass: "vjs-icon-hd",
    });

    // On click play button.
    let player = videojs("my-video");
    let videoAnalytics: any = true;
    if (environment.analyticsStatus) {
      // this.titleService.setTitle(this.options.videoDetail.name);
      const analytics = firebase.analytics();
      analytics.logEvent("view");
    }
    player.on("timeupdate", function () {
      if (
        parseInt(this.currentTime()) >= 10 &&
        videoAnalytics == true &&
        environment.analyticsStatus
      ) {
        const analytics = firebase.analytics();
        analytics.logEvent("videoWatched");
        videoAnalytics = false;
      }
    });
    if (
      this.options?.videoDetail?.view_duration &&
      this.options.videoDetail.duration !==
        this.options.videoDetail.view_duration
    ) {
      player.currentTime(this.options.videoDetail.view_duration);
    }
    if (this.options?.videoDetail?.advertisement?.id) {
      var imaOptions = {
        adTagUrl: this.options.videoDetail.advertisement.url,
      };
      player.ima(imaOptions);
    }

    //   player.ima.addEventListener(google.ima.AdEvent.Type.STARTED,()=>{
    //     console.log("alert");
    // });
    player.on("ads-request", (response) => {
      // Your code in response to the `ads-manager` event.
    });
    player.on("ads-manager", (response) => {
      var totalDuration: any = 0;
      let updateCurrentTime: any;
      var adsManager = response.adsManager;
      updateCurrentTime = adsManager.getRemainingTime();
      adsManager.addEventListener(google.ima.AdEvent.Type.COMPLETE, (data) => {
        this.callImpression(updateCurrentTime, false);
      });
      adsManager.addEventListener(
        google.ima.AdEvent.Type.AD_PROGRESS,
        (data) => {
          var adProgressData = data.getAdData();
          totalDuration = parseInt(adProgressData.duration);
          updateCurrentTime = parseInt(adProgressData.currentTime);
        }
      );
      adsManager.addEventListener(google.ima.AdEvent.Type.SKIPPED, (data) => {
        this.callImpression(updateCurrentTime, true);
      });
    });
    let shareStatus = false;
    player.bigPlayButton?.on("click", function () {
      $("#vi-content").addClass("d-none");
      $(".series-slider").removeClass("short-video");
    });
    player.on("click", function (evt) {
      if (evt.target.title == "Share") {
        shareStatus = true;
      } else {
        shareStatus = false;
      }
    });

    player.on("play", () => {
      if (!localStorage.getItem("index")) {
        localStorage.setItem("index", this.index);
        sessionStorage.setItem(
          environment.tabStorage,
          JSON.stringify({ play: true })
        );
      } else {
        if (!sessionStorage.getItem(environment.tabStorage)) {
          localStorage.setItem("index", "1");
          this.playerStatus.emit({ isPlaying: true, videoStatus: "start" });
        } else {
          this.playerStatus.emit({ isPlaying: true, videoStatus: "start" });
        }
      }

      this.is_playing = true;
      this.playerStatus.emit({
        isPlaying: true,
        videoStatus: "start",
        viewDuration: parseInt(this.player.currentTime()),
        totalDuration: parseInt(this.player.duration()),
      });
      clearTimeout(this.timeoutPause);
      $(".series-slider").removeClass("short-video");

      const encryptedData = localStorage.getItem(environment.localStorageKey);
      let encodeUrl = encodeURIComponent(this.options.redirectUrl);
      encodeUrl = CryptoJS.AES.encrypt(
        JSON.stringify(encodeUrl),
        environment.secretkey
      ).toString();
      if (encryptedData) {
        this.userInfo = JSON.parse(
          CryptoJS.AES.decrypt(encryptedData, environment.secretkey).toString(
            CryptoJS.enc.Utf8
          )
        );
      }
      const int = setInterval(() => {
        if (this.userInfo.subscription_type) {
          this.heartBeat();
        }
      }, 10000);
      this.appService.heartBeatInterval.push(int);
      if (this.options.videoDetail.is_login_required === "yes") {
        if (!encryptedData) {
          this.router.params.subscribe((params) => {
            this.route.navigate(["/login/", encodeUrl]);
          });
        }
      }
    });

    player.on("pause", () => {
      sessionStorage.removeItem(environment.tabStorage);
      localStorage.removeItem("index");
      this.is_playing = false;
      if (!shareStatus) {
        this.timeoutPause = setTimeout(() => {
          player.hasStarted(false);
          player.trigger("ready");
          this.playerStatus.emit({
            isPlaying: false,
            videoStatus: "pause",
            viewDuration: parseInt(this.player.currentTime()),
            totalDuration: parseInt(this.player.duration()),
          });
        }, 100000);
      }
    });
    player.controlBar.progressControl.seekBar.on("mouseup", (event) => {
      clearTimeout(this.timeoutPause);
    });

    player.on("ended", () => {
      sessionStorage.removeItem(environment.tabStorage);
      localStorage.removeItem("index");
      if (this.options.videoDetail.public_id) {
        const sendData = {
          contentId: this.options.videoDetail.public_id,
          viewDuration: parseInt(this.player.currentTime()),
          status: "completed",
          device_type: "web",
          totalDuration: parseInt(this.player.duration()),
          type: this.options.videoDetail.type,
          series_id: this.options.videoDetail.series_id,
          partner_id: this.options.videoDetail.posted_id,
        };
        if (
          this.player.duration() !== this.player.currentTime() &&
          parseInt(this.player.currentTime())
        ) {
          sendData.status = "incompleted";
        }

        this.appService.addContinueWatching(sendData).subscribe(
          (res) => {
            if (res) {
            }
          },
          (err) => {}
        );
      }
      this.playerStatus.emit({
        isPlaying: this.is_playing,
        videoStatus: "ended",
        viewDuration: parseInt(this.player.currentTime()),
        totalDuration: parseInt(this.player.duration()),
      });
    });
    player.on("error", () => {
      sessionStorage.removeItem(environment.tabStorage);
      localStorage.removeItem("index");
      this.playerStatus.emit({ isPlaying: true, videoStatus: "error" });
    });
    this.player.responsive(true);
    //   player.on(player, ['enterpictureinpicture', 'leavepictureinpicture'], (event)=>{

    //   });
    //
    this.player.on("enterpictureinpicture", (event) => {
      localStorage.setItem(
        environment.videoStorage,
        JSON.stringify({ pip: true })
      );
    });

    this.player.on("leavepictureinpicture", (event) => {
      this.player.pause();
      localStorage.removeItem(environment.videoStorage);
    });
    this.player.on("loadedmetadata", () => {
      setTimeout(() => {
        if (localStorage.getItem(environment.videoStorage)) {
          this.player.requestPictureInPicture();
        }
      }, 500);
    });
  }
  heartBeat() {
    var sendData = { device_id: this.userInfo.deviceId };
    this.appService.heartBeat(sendData).subscribe(
      (res) => {
        if (res.logout) {
          localStorage.clear();
          this.route.navigate(["/"]);
        }
      },
      (err) => {
        if (err.status == 401 && err.type === "heart_beat") {
          localStorage.clear();
          this.route.navigate(["/login"]);
        } else {
          this.route.navigate(["/home"]);
        }
      }
    );
  }

  callImpression(updateCurrentTime, status) {
    let sendData = {
      content_id: this.options.videoDetail.public_id,
      partner_id: this.options.videoDetail.posted_id,
      view_duration: updateCurrentTime,
      skip_status: status,
      device_type: "web",
      total_duration: updateCurrentTime,
      type: this.options.videoDetail.type,
      series_id: "",
      url: this.options.videoDetail.advertisement.url
        ? this.options.videoDetail.advertisement.url
        : "",
      advertisement_id: this.options.videoDetail.advertisement.id
        ? this.options.videoDetail.advertisement.id
        : "",
    };
    if (this.options.videoDetail.type == "series") {
      sendData.series_id = this.options.videoDetail.public_id;
    }
    this.appService.addImpression(sendData).subscribe(
      (res) => {
        if (res) {
          clearInterval(updateCurrentTime);
        }
      },
      (err) => {
        clearInterval(updateCurrentTime);
      }
    );
  }
  ngOnDestroy() {
    sessionStorage.removeItem(environment.tabStorage);
    localStorage.removeItem("index");
    if (localStorage.getItem(environment.localStorageKey)) {
      if (
        this.player.duration() !== this.player.currentTime() &&
        parseInt(this.player.currentTime())
      ) {
        if (this.options.videoDetail.public_id) {
          const sendData = {
            contentId: this.options.videoDetail.public_id,
            viewDuration: parseInt(this.player.currentTime()),
            status: "incompleted",
            device_type: "web",
            totalDuration: parseInt(this.player.duration()),
            type: this.options.videoDetail.type,
            series_id: this.options.videoDetail.series_id,
            partner_id: this.options.videoDetail.posted_id,
          };

          this.appService.addContinueWatching(sendData).subscribe(
            (res) => {},
            (err) => {}
          );
        }
      }
    }
    if (
      this.appService.heartBeatInterval.length > 0 &&
      !localStorage.getItem(environment.videoStorage)
    ) {
      this.appService.heartBeatInterval.forEach((element) => {
        clearInterval(element);
      });
    }
    if (this.player && !localStorage.getItem(environment.videoStorage)) {
      this.player.dispose();
    }
  }

  triggerControlBtns() {
    var pipButton = $(".vjs-picture-in-picture-control");
    pipButton.trigger("click");
  }

  getYScrollandVideoStatus(position: number) {
    if (this.player.paused()) {
      if (position > 100) {
        $(".series-slider").removeClass("short-video");
        $(".frame-video").removeClass("btn-set-top");
        $("#vi-content").removeClass("set-top");
      } else if (position <= 0) {
        $("#vi-content").addClass("set-top");
        $(".frame-video").addClass("btn-set-top");
        $(".series-slider").addClass("short-video");
      }
    }
  }
}
